export const LOAD_CATEGORY_ENTRIES = 'LOAD_CATEGORY_ENTRIES';
export const LOAD_CATEGORY_ENTRIES_STARTED = 'LOAD_CATEGORY_ENTRIES_STARTED';
export const LOAD_CATEGORY_ENTRIES_ERROR = 'LOAD_CATEGORY_ENTRIES_ERROR';
export const LOAD_CATEGORY_ENTRIES_SUCCESS = 'LOAD_CATEGORY_ENTRIES_SUCCESS';

export const SET_PAGE_SORT = 'SET_PAGE_SORT';
export const SET_PAGE = 'SET_PAGE';
export const SET_ROWS_PER_PAGE = 'SET_ROWS_PER_PAGE';
export const SET_PAGE_NUMBER = 'SET_PAGE_NUMBER';
export const SET_SELECTED_CATEGORY_ID = 'SET_SELECTED_CATEGORY_ID';
export const SET_CATEGORIES = 'SET_CATEGORIES';

export default {
    LOAD_CATEGORY_ENTRIES, LOAD_CATEGORY_ENTRIES_STARTED, LOAD_CATEGORY_ENTRIES_ERROR, LOAD_CATEGORY_ENTRIES_SUCCESS,
    SET_PAGE, SET_PAGE_NUMBER, SET_PAGE_SORT, SET_ROWS_PER_PAGE, SET_SELECTED_CATEGORY_ID, SET_CATEGORIES
};